module.exports = __webpack_public_path__ + "static/media/Success.af501ee6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Success.svg
// module id = 80
// module chunks = 0